/**
 * Created by Dong on 2018/6/12.
 */
import React, {Component} from 'react';
import './style.scss'
import {notification,Button } from 'antd'
import ReactDOM from 'react-dom'
class LeaveMsg extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    /**
     * view
     */
    async　viewMsgHandle() {
        let {notificationKey,actions,flowId}=this.props;

        let aDom = document.getElementsByTagName('a')[3];
        let aReactDom = ReactDOM.findDOMNode(aDom);
        aReactDom.click();
        notification.close(notificationKey);
        // actions.setCurrentReport(flowId);
        actions.getCreateReport('update');
        actions.getLatestReport(flowId)
        actions.changeActiveReportTab("5")
    };
    /**
     * Half a moment
     */
    waitMsgHandle = ()=> {
        let {notificationKey}=this.props;
        notification.close(notificationKey);
    };

    render() {
        let {newMsg}=this.props;
        return (
            <div><p className="leaveMsg_p">{newMsg}</p>

                <div className="leaveMsg_div_btn_c">
                    <Button type="primary" onClick={this.waitMsgHandle.bind(this)} size="small">稍后</Button>
                    <Button type="primary" onClick={this.viewMsgHandle.bind(this)} size="small">立即处理</Button>
                </div>
            </div>
        )
    }
}

export default LeaveMsg